import React from 'react'
import { ISpeaker } from '../index'
import { Image } from 'marketing-site/src/library/elements/Image'
import styles from './avatars.scss'

interface IAvatars {
  speakers: ISpeaker[]
}

export function WebinarAvatars({ speakers }: IAvatars) {
  return (
    <div className="webinar__avatars">
      {speakers.map((speaker, index) => {
        return (
          speaker.image && (
            <div className={`webinar__avatar webinar__avatar--${index}`} key={speaker.name}>
              <Image url={speaker.image} />
            </div>
          )
        )
      })}
      <style jsx>{styles}</style>
    </div>
  )
}
